
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Location() {
  const navigate = useNavigate();
  const [address, setAddress] = useState('');
  const [savedAddresses] = useState([
    { id: 1, name: 'المنزل', address: 'حي النخيل، شارع الملك فهد، الرياض' },
    { id: 2, name: 'العمل', address: 'حي العليا، برج المملكة، الرياض' }
  ]);

  const handleSave = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen bg-[#F6F6F6] pb-24">
      {/* Header */}
      <div className="bg-gradient-to-br from-[#1565C0] to-[#2E7D32] pt-12 pb-6 px-6">
        <div className="flex items-center gap-3 animate-fadeIn">
          <button onClick={() => navigate(-1)} className="w-9 h-9 bg-white/20 rounded-xl flex items-center justify-center">
            <i className="ri-arrow-right-line text-white text-lg"></i>
          </button>
          <h1 className="text-xl font-bold text-white">تحديد الموقع</h1>
        </div>
      </div>

      {/* Map Placeholder */}
      <div className="relative h-64 bg-gray-200">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d463876.8684129!2d46.5423!3d24.7136!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f03890d489399%3A0xba974d1c98e79fd5!2sRiyadh%20Saudi%20Arabia!5e0!3m2!1sen!2s!4v1"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
        ></iframe>
        
        {/* Center Pin */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-full">
          <div className="w-10 h-10 bg-[#1565C0] rounded-full flex items-center justify-center shadow-lg animate-bounce">
            <i className="ri-map-pin-fill text-white text-xl"></i>
          </div>
        </div>

        {/* Current Location Button */}
        <button className="absolute bottom-4 left-4 w-12 h-12 bg-white rounded-xl shadow-lg flex items-center justify-center">
          <i className="ri-focus-3-line text-[#1565C0] text-xl"></i>
        </button>
      </div>

      {/* Address Input */}
      <div className="px-6 -mt-4">
        <div className="bg-white rounded-2xl p-5 shadow-lg animate-slideUp">
          <h3 className="font-bold text-[#212121] mb-3 flex items-center gap-2">
            <i className="ri-map-pin-line text-[#1565C0]"></i>
            العنوان
          </h3>
          <textarea
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            placeholder="أدخل تفاصيل العنوان..."
            className="w-full bg-[#F6F6F6] rounded-xl p-3 outline-none text-sm resize-none"
            rows={3}
          />
        </div>
      </div>

      {/* Saved Addresses */}
      <div className="px-6 mt-6">
        <h3 className="font-bold text-[#212121] mb-3">العناوين المحفوظة</h3>
        <div className="space-y-3">
          {savedAddresses.map((item, index) => (
            <button
              key={item.id}
              onClick={() => setAddress(item.address)}
              className="w-full bg-white rounded-xl p-4 shadow-sm hover:shadow-md transition-all text-right animate-slideUp"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-[#1565C0]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className={`${item.name === 'المنزل' ? 'ri-home-4-line' : 'ri-building-line'} text-[#1565C0]`}></i>
                </div>
                <div className="flex-1">
                  <h4 className="font-semibold text-[#212121] mb-1">{item.name}</h4>
                  <p className="text-sm text-gray-500">{item.address}</p>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* Save Button */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 p-4 shadow-lg">
        <button
          onClick={handleSave}
          className="w-full bg-gradient-to-l from-[#1565C0] to-[#2E7D32] text-white py-4 rounded-xl font-bold shadow-lg hover:shadow-xl transition-all active:scale-[0.98]"
        >
          حفظ العنوان
        </button>
      </div>
    </div>
  );
}
